/* eslint-disable import/prefer-default-export */
export { ReactComponent as LedgerThingsLogo } from './svg/logo/logo-named.svg';
export { ReactComponent as RedwingsLogo } from './svg/redwinglabs_logo.svg';
export { ReactComponent as QuadroLogo } from './svg/quadro_logo.svg';
export { ReactComponent as TopUpIcon } from './svg/go_top.svg';
export { ReactComponent as BackIcon } from './svg/home/back-icon.svg';
export { ReactComponent as CheckIcon } from './svg/home/check.svg';
export { ReactComponent as PlusIcon } from './svg/home/plus.svg';
export { ReactComponent as ForwardIcon } from './svg/home/forward-icon.svg';
export { ReactComponent as GridPattern } from './svg/grid-pattern.svg';
export { ReactComponent as ItalianFlagIcon } from './svg/italian-flag-footer.svg';
export { ReactComponent as AmericanFlagIcon } from './svg/american-flag-footer.svg';
export { ReactComponent as DigitPattern } from './svg/home/digit-pattern.svg';
export { ReactComponent as QuadroRedLogo } from './svg/home/quadro-red.svg';
export { ReactComponent as DiscordIcon } from './svg/social/discord.svg';
export { ReactComponent as TwitterIcon } from './svg/social/twitter.svg';
export { ReactComponent as GithubIcon } from './svg/social/github.svg';
export { ReactComponent as InstagramIcon } from './svg/social/instagram.svg';
export { ReactComponent as TelegramIcon } from './svg/social/telegram.svg';
export { ReactComponent as FacebookIcon } from './svg/social/facebook.svg';
export { ReactComponent as MediumIcon } from './svg/social/medium.svg';
export { ReactComponent as YoutubeIcon } from './svg/social/youtube.svg';
export { ReactComponent as LinkedinIcon } from './svg/social/linkedin.svg';
export { ReactComponent as ArrowDownIcon } from './svg/arrow-down.svg';
export { ReactComponent as EnFlagIcon } from './svg/en-flag.svg';
export { ReactComponent as ItFlagIcon } from './svg/it-flag.svg';
export { ReactComponent as CrossIcon } from './svg/cross.svg';

//  BACKGROUND
export { ReactComponent as BGPms } from './svg/bg-intro/bg-pms.svg';
export { ReactComponent as BGFnb } from './svg/bg-intro/bg-fnb.svg';
export { ReactComponent as BGPop } from './svg/bg-intro/bg-pop.svg';
export { ReactComponent as BGEntertainment } from './svg/bg-intro/bg-entertainment.svg';

// CAROUSEL
export { ReactComponent as CarouselPms } from './svg/home/carousel/pms.svg';
export { ReactComponent as CarouselFnb } from './svg/home/carousel/fnb.svg';
export { ReactComponent as CarouselPop } from './svg/home/carousel/pop.svg';
export { ReactComponent as CarouselEntertainment } from './svg/home/carousel/entertainment.svg';

// PRODUCTS LINK
export { ReactComponent as ProductPms } from './svg/product/product-pms.svg';
export { ReactComponent as ProductFnb } from './svg/product/product-fnb.svg';
export { ReactComponent as ProductPop } from './svg/product/product-pop.svg';
export { ReactComponent as ProductEntertainment } from './svg/product/product-entertainment.svg';

// PRODUCTS QUADRO IMAGES
export { ReactComponent as DescriptionQuadroEntertainment } from './svg/product/desc-quadro-ent.svg';
export { ReactComponent as DescriptionQuadroEntertainmentTv } from './svg/product/desc-quadro-ent-tv.svg';
export { ReactComponent as DescriptionQuadroPms } from './svg/product/desc-quadro-pms.svg';
export { ReactComponent as DescriptionQuadroPmsMobile } from './svg/product/desc-quadro-pms-mobile.svg';
export { ReactComponent as DescriptionQuadroFnb } from './svg/product/desc-quadro-fnb.svg';
export { ReactComponent as DescriptionQuadroFnbSpaces } from './svg/product/desc-quadro-fnb-spaces.svg';
export { ReactComponent as DescriptionQuadroPop } from './svg/product/desc-quadro-pop.svg';
export { ReactComponent as DescriptionQuadroPopAddress } from './svg/product/desc-quadro-pop-address.svg';

export { ReactComponent as QuadroPmsTimeline } from './svg/product/quadro-timeline.svg';
export { ReactComponent as QuadroPopInventory } from './svg/product/quadro-pop-inventory.svg';
export { ReactComponent as QuadroFnbSpaces } from './svg/product/quadro-fnb-spaces.svg';
export { ReactComponent as QuadroEntertainmentMockup } from './svg/product/quadro-ent-mockup.svg';

// PNG
export const ltLogo = '/logo/logo-named.png';
export const ltLogoColor = '/logo/logo-colored-named.png';
